// https://github.com/module-federation/universe/issues/2280
await import('./bootstrap');

export {};
